/**
 * Tracks whether the current tab's session began with a magic link.
 *
 * A magic-link user never sees the temporary password an admin generated for
 * them, so the forced password-change form must not ask for it. The backend
 * doesn't distinguish the two sign-in routes (both return the same auth token),
 * so the frontend records it at sign-in time.
 */
const MAGIC_LINK_SIGN_IN_KEY = "signedInViaMagicLink"

export const markMagicLinkSignIn = () => {
  sessionStorage.setItem(MAGIC_LINK_SIGN_IN_KEY, "1")
}

export const signedInViaMagicLink = () =>
  sessionStorage.getItem(MAGIC_LINK_SIGN_IN_KEY) === "1"

export const clearMagicLinkSignIn = () => {
  sessionStorage.removeItem(MAGIC_LINK_SIGN_IN_KEY)
}
